import { customSinkListItem } from "../../../commands/custom-commands";
//import { sinkListItem } from "prosemirror-schema-list";
import { customSchema } from "../../../schemas/custom-schema";

export default class IndentListButton {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button disabled--hidden";
    this.buttonElement.title = "Anidar";
    this.buttonElement.dataset.action = "indent";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "Anidar";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "Anidar";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);
    this.buttonAction = this.buttonClickCallback();
    this.rejectFocusAction = this.buttonMouseDownCallback();
    this.buttonElement.addEventListener("click", this.buttonAction);
    this.buttonElement.addEventListener("mousedown", this.rejectFocusAction);
    containerElement.appendChild(this.buttonElement);
    this.update(editorView);
  }

  update(view) {
    const isEnabled = customSinkListItem(customSchema.nodes.listItem)(view.state, null); //isNodeActive(this.view.state, customSchema.nodes.listItem) && sinkListItem(customSchema.nodes.listItem)(this.view.state, null);
    this.buttonElement.disabled = !isEnabled;
    this.view = view;
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.buttonAction);
    this.buttonElement.removeEventListener("mousedown", this.rejectFocusAction);
    this.buttonElement.remove();
    this.buttonElement = null;
    this.buttonAction = null;
    this.rejectFocusAction = null;
    this.view = null;
  }

  buttonMouseDownCallback() {
    return (event) => {
      event.preventDefault();
    }
  }

  buttonClickCallback() {
    return () => {
      customSinkListItem(customSchema.nodes.listItem)(this.view.state, this.view.dispatch);
    }
  }
}
